// src/components/ui/Input.jsx
// Использование:
//   <Input label="Email" placeholder="info@company.kz" />
//   <Input label="БИН" icon={<Hash size={16} />} error="Обязательное поле" />
//   <Input label="Сообщение" multiline rows={3} />
//   <Input label="Email" required optional={false} />

import React from 'react';
import { AlertCircle } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export const Input = ({
  label,
  placeholder,
  value,
  onChange,
  icon,
  error,
  type = 'text',
  multiline = false,
  rows = 3,
  required = false,
  optional = false,
  maxLength,
  inputMode,
  className = '',
  children, // для кастомного контента внутри (маска БИН и тд)
}) => {
  const { t } = useTranslation();
  const baseClass = `
    w-full bg-gray-50 border rounded-sm py-4 pr-4 text-sm text-gray-900
    outline-none placeholder:text-gray-500
    transition-all focus:border-brand-accent/60
    ${icon ? 'pl-11' : 'pl-4'}
    ${error ? 'border-brand-danger-text/50' : 'border-gray-200'}
  `;

  return (
    <div className={className}>
      {label && (
        <label className="text-label font-black uppercase tracking-widest text-gray-400 mb-1.5 block">
          {label}
          {required && <span className="text-brand-danger-text ml-1">*</span>}
          {optional && <span className="text-gray-500 ml-1">{t('ui_Input.optional')}</span>}
        </label>
      )}
      <div className="relative">
        {icon && (
          <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 z-10 pointer-events-none">
            {icon}
          </div>
        )}
        {children}
        {multiline ? (
          <textarea
            rows={rows}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={`${baseClass} resize-none`}
          />
        ) : (
          <input
            type={type}
            inputMode={inputMode}
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            maxLength={maxLength}
            className={`${baseClass}${children ? ' text-transparent caret-transparent' : ''}`}
          />
        )}
      </div>
      {error && (
        <p className="text-brand-danger-text text-[10px] mt-1 flex items-center gap-1">
          <AlertCircle size={10} /> {error}
        </p>
      )}
    </div>
  );
};
